import { observable, action, runInAction } from 'mobx'
import api from '../api'

class PasswordRecoverStore {
  @observable email = ''
  @observable send = false

  @action.bound setEmail(email) {
    this.email = email
  }

  @action.bound async sendRecoverRequest(altchaPayload) {
    try {
      await api.User.passwordRecover(this.email, altchaPayload)
      runInAction(() => {
        this.send = true
      })
    } catch(error) {
    }
  }
}

export default new PasswordRecoverStore()



// WEBPACK FOOTER //
// ./src/stores/passwordRecoverStore.js